import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import '../shared/styles.css';
import { ToastProvider } from '../shared/ui';
import { AdminApp } from './AdminApp';

// HashRouter: el panel se sirve desde /admin.html y las rutas no deben pedir otra página al servidor.
createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <HashRouter>
      <ToastProvider>
        <AdminApp />
      </ToastProvider>
    </HashRouter>
  </StrictMode>,
);
